import { ROLES } from '@/constants/roles';

export const profile = {
  path: '/profile',
  component: () => import('./views/Profile/index.vue'),
  meta: {
    title: 'Профиль',
    icon: '$iuser',
    accessList: [ROLES.organization, ROLES.department, ROLES.operator, ROLES.expert],
    layout: 'empty',
  },
};

export const profileHistory = {
  path: '/profile/history',
  name: 'profile-history',
  component: () => import('./views/event-results/index.vue'),
  meta: {
    title: 'Результаты',
    icon: 'mdi-trophy-award',
    accessList: [ROLES.certificate, ROLES.member],
    instruction: {
      id: 36,
      name: 'Результаты',
    },
  },
};

export const CertificateBrowse = {
  name: 'event-certificate-browse',
  path: '/event-certificate/:id',
  component: () => import('./views/event-results/CertificateBrowse.vue'),
  meta: {
    title: 'Просмотр грамоты',
    icon: 'mdi-trophy-award',
    layout: 'redesign',
  },
};

const MY_PROFILE_SUBMENU = [
  {
    to: '/my-profile',
    text: 'Основное',
    icon: 'mdi-account-circle-outline',
    visibleFor: [ROLES.trainer, ROLES.certificate, ROLES.member, ROLES.organization, ROLES.expert, ROLES.event_manager],
  },
  {
    to: '/my-profile/portfolio',
    text: 'Портфолио',
    icon: 'mdi-folder-outline',
    visibleFor: [ROLES.certificate, ROLES.member, ROLES.expert],
  },
  {
    to: '/my-profile/widgets',
    text: 'Виджеты',
    icon: 'mdi-widgets',
    visibleFor: [ROLES.organization],
  },
  {
    to: '/my-profile/duplicate',
    text: 'Управление доступом',
    icon: 'mdi-account-multiple-outline',
    visibleFor: [ROLES.organization],
  },
  {
    to: '/my-profile/duplicate',
    text: 'Модераторы',
    icon: 'mdi-account-multiple-outline',
    visibleFor: [ROLES.operator, ROLES.department],
  },
  {
    to: '/my-profile/settings',
    text: 'Настройки',
    icon: 'mdi-cog',
    visibleFor: [ROLES.trainer, ROLES.expert],
  },
  {
    to: '/my-profile/additional',
    text: 'Дополнительные',
    icon: 'mdi-folder-cog',
    visibleFor: [ROLES.certificate, ROLES.member],
  },
];

export const myPortfolio = {
  path: '/my-profile/portfolio',
  component: () => import('./views/Profile/Portfolio.vue'),
  meta: {
    title: 'Портфолио',
    accessList: [ROLES.expert, ROLES.certificate, ROLES.member],
    icon: 'mdi-information-outline',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myProfileDuplicate = {
  path: '/my-profile/duplicate',
  component: () => import('./views/DuplicateAccount/index.vue'),
  meta: {
    title: 'Управление доступом',
    accessList: [ROLES.organization],
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myModerators = {
  path: '/my-profile/duplicate',
  component: () => import('./views/DuplicateAccount/index.vue'),
  meta: {
    title: 'Модераторы',
    accessList: [ROLES.operator, ROLES.department],
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myProfileAdditional = {
  path: '/my-profile/additional',
  component: () => import('./views/Profile/Additional.vue'),
  meta: {
    title: 'Дополнительные настройки',
    accessList: [ROLES.expert, ROLES.certificate, ROLES.member],
    icon: 'mdi-information-outline',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myProfileWidgets = {
  path: '/my-profile/widgets',
  component: () => import('./views/Profile/Widgets.vue'),
  meta: {
    title: 'Виджеты',
    accessList: [ROLES.organization],
    icon: 'mdi-widgets',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myProfileSettings = {
  path: '/my-profile/settings',
  component: () => import('./views/Profile/Settings.vue'),
  meta: {
    title: 'Настройки',
    accessList: [ROLES.trainer, ROLES.expert, ROLES.certificate, ROLES.member, ROLES.organization],
    icon: 'mdi-information-outline',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const myProfile = {
  path: '/my-profile',
  name: 'profile',
  component: () => import('./views/Profile/index.vue'),
  meta: {
    title: 'Профиль',
    accessList: [ROLES.trainer, ROLES.expert, ROLES.certificate, ROLES.member, ROLES.organization, ROLES.event_manager],
    icon: '$iuser',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const uiMyProfile = {
  path: '/my-org-profile',
  name: 'ui-profile',
  component: () => import('./views/Profile/index.vue'),
  meta: {
    // title: 'Профиль',
    accessList: [ROLES.organization],
    layout: 'ui-design',
    icon: '$iuser',
    drawerChildren: MY_PROFILE_SUBMENU,
  },
};

export const changeEmail = {
  path: '/change-email',
  name: 'change-email',
  component: () => import('./views/Profile/ConfirmChangeEmail.vue'),
  meta: {
    title: 'Изменение почты',
    guest: true, // Добавил это, чтобы пустой экран не появлялся, когда по ссылке переходят
    // accessList: [ROLES.trainer, ROLES.expert, ROLES.certificate, ROLES.member, ROLES.organization],
  },
};

export const confirmTransfer = {
  path: '/transfer-confirm',
  name: 'transfer-confirm',
  component: () => import('./views/transfer-confirm.vue'),
  meta: {
    title: 'Подтверждение привязки',
  },
};

const routes = [
  profile,
  profileHistory,
  CertificateBrowse,

  // Remaked profile
  myProfile,
  myPortfolio,
  myProfileWidgets,
  myProfileAdditional,
  myProfileSettings,
  myProfileDuplicate,
  myModerators,
  changeEmail,

  // ui
  uiMyProfile,

  confirmTransfer,
];

export default routes;
